
// === global.js START ============================================================================

// ----------------------------------------------------------------------------
// --- global standard javascript variables -----------------------------------
// ----------------------------------------------------------------------------

/**
 * The current event model. Can be empty, but not null as long as the wizard is open
 */
var currentEvent = null;

/**
 * The current wizard step, from the wizardSteps variable
 */
var currentStep = null;

/**
 * Current FullCalendar Resource GUID String
 */
var currentResource = null;

/**
 * The user's profile configuration. Loaded via ajax.
 * This is supposed to replace calendarConfiguration at some point,
 * so that the calendar web does not depend on the data layer anymore
 * but get all it's stuff from the API.
 */
var profileConfiguration = null;

/**
 * The current multicard, or null, if there is none.
 * Deprecated.
 */
var currentMultiCard = null;

/**
 * The pro's contact list
 * TODO Club / location awarenenss
 */
var contactList = [];

/**
 * The list of all academy pros (maybe for a given location)
 */
var academyProList = [];

/** stepStack
 * - step names are pushed if opened
 * - the 'back' button uses this stack to navigate
 */
var stepStack = [];

/** moneyValidation
 * - money validation regex for the wizard
 * */

var moneyRegex = /^\d{0,4}(\.\d{0,2})?$/;

/**
 * All available wizard steps.
 * Populated by the 010_wizardStep* files
 */
var wizardSteps = {};

/**
 * Internally used - all available buttons are defined here.
 * Which buttons are shown is defined by the wizardStep's getButtonList function.
 */
var buttonTemplate = null;

/**
 * -Detect if device is having touch capabilities
 * */
var isTouchCapable = 'ontouchstart' in window ||
    window.DocumentTouch && document instanceof window.DocumentTouch ||
    navigator.maxTouchPoints > 0 ||
    window.navigator.msMaxTouchPoints > 0;

// ----------------------------------------------------------------------------
// --- global JQuery object variables -----------------------------------------
// ----------------------------------------------------------------------------

/** $calendar
 * - FullCalendar module container (JQuery object)
 */
var $calendar = $('.m-mamp-calendar');

/** Modal PopUp module container (JQuery object) */
var $modal = $('.m-modal');

var PaymentStatus;
(function(paymentStatus) {
    paymentStatus[paymentStatus["Unpaid"] = 0] = "Unpaid";
    paymentStatus["Pending"] = 0;
    paymentStatus[paymentStatus["Free"] = 1] = "Free";
    paymentStatus[paymentStatus["PaidCash"] = 2] = "PaidCash";
    paymentStatus["PaidManual"] = 2;
    paymentStatus[paymentStatus["PaidStripe"] = 3] = "PaidStripe";
    paymentStatus[paymentStatus["PaidFlatrate"] = 4] = "PaidFlatrate";
    paymentStatus[paymentStatus["PaidMulticard"] = 5] = "PaidMulticard";
    paymentStatus[paymentStatus["PaidPrepaidCard"] = 6] = "PaidPrepaidCard";
    paymentStatus[paymentStatus["PaymentPendingStripe"] = 7] = "PaymentPendingStripe";
    paymentStatus[paymentStatus["PaymentPendingPrepaidCard"] = 8] = "PaymentPendingPrepaidCard";
    paymentStatus[paymentStatus["PaidCashDone"] = 9] = "PaidCashDone";
    paymentStatus[paymentStatus["Transfer"] = 10] = "Transfer";
    paymentStatus[paymentStatus["Cancellation"] = 11] = "Cancellation";
})(PaymentStatus || (PaymentStatus = {}));

var PaymentStatusTransitions;
(function(paymentStatus) {
    paymentStatus.push({
        key: 0,
        value: "Unpaid"
    });
    paymentStatus.push({
        key: 1,
        value: "Free"
    });
    paymentStatus.push({
        key: 2,
        value: "PaidCash"
    });
    paymentStatus.push({
        key: 9,
        value: "PaidCashDone"
    });
    paymentStatus.push({
        key: 10,
        value: "Transfer"
    });
    paymentStatus.push({
        key: 11,
        value: "Cancellation"
    });
    paymentStatus.push({
        key: 6,
        value: "PaidPrepaidCard"
    });
})(PaymentStatusTransitions || (PaymentStatusTransitions = []));

var paymentStatusTranslations = {
    "Unpaid": "PAYMENTINFO_UNPAID",
    "Free": "PAYMENTINFO_FREE",
    "PaidCash": "PAYMENTINFO_CASH",
    "PaidStripe": "PAYMENTINFO_ONLINE",
    "PaidFlatrate": "PAYMENTINFO_FLATRATE",
    "PaidMulticard": "PAYMENTINFO_MULTICARD",
    "PaidPrepaidCard": "PAYMENTINFO_PREPAIDCARD",
    "PaymentPendingStripe": "PAYMENTINFO_STRIPE_PENDING",
    "PaymentPendingPrepaidCard": "PAYMENTINFO_PREPAIDCARD_PENDING",
    "PaidCashDone": "PAYMENTINFO_CASH_DONE"
};

if (!String.prototype.format) {
    String.prototype.format = function() {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function(match, number) {
            return typeof args[number] !== 'undefined'
                       ? args[number]
                       : match
                ;
        });
    };
}

if (typeof Object.assign !== 'function') {
    Object.assign = function(target) {
        'use strict';
        if (target === null || typeof target === 'undefined') {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== null && typeof target !== 'undefined') {
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };
}

// ----------------------------------------------------------------------------
// --- global configuration----------------------------------------------------
// ----------------------------------------------------------------------------

// Force en-gb to format time in 12 hour am/pm style.
var localeFix = moment();
localeFix.locale('en-gb');
localeFix._locale._config.longDateFormat['LT'] = 'h:mm A';
localeFix._locale._config.longDateFormat['LTS'] = 'h:mm:ss A';

moment.locale(calendarConfiguration.locale.toLowerCase());
if (moment.locale() !== calendarConfiguration.locale.toLowerCase()) {
    moment.locale(calendarConfiguration.locale.substr(0, 2));
}

var dateTimeFormatString = {
    dateFormat: moment()._locale._config.longDateFormat['L'],
    dateFormatPicker: moment()._locale._config.longDateFormat['L'].replace('YYYY', 'YY').toLowerCase(),
    timeFormat: moment()._locale._config.longDateFormat['LT']
};

// === global.js END ==============================================================================
